import { ComponentProps } from 'react';
import { Button as PaperButton } from 'react-native-paper';
import { StyleSheet } from 'react-native';

import { useThemeContext } from '../../contexts';

export type ButtonProps = ComponentProps<typeof PaperButton>;

export const Button = (props: ButtonProps) => {
  const { theme } = useThemeContext();
  const styles = StyleSheet.create({
    content: {
      backgroundColor: theme.colors.primary,
    },
    disabled: {
      backgroundColor: theme.colors.surfaceDisabled,
    },
    label: {
      color: theme.colors.surface,
      textTransform: 'none',
      fontSize: 15,
      fontWeight: 'bold',
    },
  });
  return (
    <PaperButton
      labelStyle={[styles.label, props.labelStyle]}
      contentStyle={[styles.content, props.contentStyle, props.disabled ? styles.disabled : {}]}
      {...props}
    />
  );
};
